
import React, { useState } from 'react';
import { useSelector} from 'react-redux'
import './carddaydisplay.css'

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import 'rc-slider/assets/index.css';


var moment = require('moment')
const SummaryPlanDisplay = (props) => {
  const {
    buttonLabel,
    className
  } = props;


  //const dispatch = useDispatch()


  

  

  //console.log(state)
  const [modal, setModal] = useState(false);
  

 
  const toggle = () => setModal(!modal);
  
  

  const additionalData = () =>{
    if (props.data.subType){
      if  (props.data.subType.includes("Interval")){
        console.log(props.data)
        
          return `Run ${props.data.addData[0]} minutes (high intensity), ${props.data.addData[1]} minutes (low Intensity). Repeat ${(props.data.addData.length/2).toFixed(0)} times`
        
        
       
      }
    }
  }
  
  
  

  
   
  
  
  var totalDistance = 0
  var totalDuration = 0
  var totalTss = 0
  for (var i=0;i<7;i++){
      totalDistance = totalDistance + Number(props.summaryList[i][1])
      totalDuration = totalDuration + Number(props.summaryList[i][0])
      totalTss = totalTss + Number(props.summaryList[i][2])

  }
  
 
  const weekDate = () => {
    if (props.week.date !== undefined){
        var dateWeekOne = props.week.date.split(" ")
        var dateWeekTwo = moment(props.week.date).add(6,'day')
        dateWeekTwo = (dateWeekTwo).toString()
        dateWeekTwo = dateWeekTwo.split(" ")
        var dateWeek = `${dateWeekOne[1]} ${dateWeekOne[2]} - ${dateWeekTwo[2]} ${dateWeekTwo[1]}`
        return dateWeek
    }
    else{
        return " -- "
    }
      
  }
  return (
    <div>
      <img alt="" onClick={toggle} style={{cursor:'pointer'}} src={props.Summary} ></img>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Week summary</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">

                <div className="cardDisplay">
              
              
              <h2 className="name text-white">{weekDate()}</h2>
              
              <div className="title">{props.data.type}</div>
              
              <div className="actions">
              <div className="follow-info">
                <h2><a href="#"><span className="text-success">{totalDuration}</span><small>Duration</small></a></h2>
                
                  <h2><a href="#"><span className="text-white" >{totalDistance.toFixed(2)}</span><small>Total Estimated Distance (km)</small></a></h2>
                  
                  

                
              </div>
              <div className="follow-info">
                

                  
                  <h2><a href="#"><span className="text-danger">{totalTss}</span><small>Stress Score</small></a></h2>
            
                
            
              </div>
                <div className="follow-btn">
                  <button className="text-white">--</button>
                </div>
              </div>
              
              <div className="desc"></div>
            </div>
            

  
        
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SummaryPlanDisplay;